export const validateExcelFile = (file) => {
  const ext = file.name.split('.').pop().toLowerCase();
  return ['xlsx'].includes(ext);
}